(() => {
  if (window.__cmPopupUpsellInit) return;
  window.__cmPopupUpsellInit = true;

  console.log('[cm-popup-upsell] script loaded');

  const popup = document.querySelector('[data-cm-popup-upsell]');
  if (!popup) {
    console.warn('[cm-popup-upsell] popup not found (snippet not rendered).');
    return;
  }

  // Stabilt: undgå overflow/stacking issues
  if (popup.parentElement !== document.body) {
    document.body.appendChild(popup);
  }

  const btnAddUpsell = popup.querySelector('[data-cm-popup-add]');

  const open = () => {
    popup.hidden = false;
    popup.removeAttribute('hidden');
    document.documentElement.classList.add('cm-popup-upsell--open');
    console.log('[cm-popup-upsell] OPEN');
  };

  const close = () => {
    popup.hidden = true;
    document.documentElement.classList.remove('cm-popup-upsell--open');
    console.log('[cm-popup-upsell] CLOSE');
  };

  // Luk-handlers
  popup.querySelectorAll('[data-cm-popup-close]').forEach(el => el.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  // Hent HTML og opdater kun drawerens indhold + subtotal
  const refreshCartDrawer = async () => {
    const drawer = document.querySelector('#site-cart');
    if (!drawer) {
      console.warn('[cm-popup-upsell] #site-cart not found');
      return;
    }

    const currentContent = drawer.querySelector('#cm-cart-drawer-content');
    const currentSubtotal = drawer.querySelector('#AjaxCartSubtotal');

    if (!currentContent && !currentSubtotal) {
      console.warn('[cm-popup-upsell] Neither #cm-cart-drawer-content nor #AjaxCartSubtotal found inside #site-cart');
      return;
    }

    const url = `${window.location.pathname}${window.location.search}`;
    const res = await fetch(url, { headers: { 'Accept': 'text/html' } });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Find de “nye” elementer i den server-renderede HTML
    const nextDrawer = doc.querySelector('#site-cart');
    if (!nextDrawer) {
      console.warn('[cm-popup-upsell] Could not find #site-cart in fetched HTML');
      return;
    }

    const nextContent = nextDrawer.querySelector('#cm-cart-drawer-content');
    const nextSubtotal = nextDrawer.querySelector('#AjaxCartSubtotal');

    if (currentContent && nextContent) {
      currentContent.innerHTML = nextContent.innerHTML;
    } else {
      console.warn('[cm-popup-upsell] content swap skipped (missing current/next #cm-cart-drawer-content)');
    }

    if (currentSubtotal && nextSubtotal) {
      currentSubtotal.innerHTML = nextSubtotal.innerHTML;
    } else {
      console.warn('[cm-popup-upsell] subtotal swap skipped (missing current/next #AjaxCartSubtotal)');
    }

    // Opdater evt. cart count i drawer (hvis den findes)
    const nextCount = nextDrawer.querySelector('[data-cart-count]');
    const currentCount = drawer.querySelector('[data-cart-count]');
    if (nextCount && currentCount) currentCount.textContent = nextCount.textContent;

    console.log('[cm-popup-upsell] cart drawer refreshed');
  };

  // Trigger: klik på produktets add-to-cart knap (åbn popup)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product__add-to-cart');
    if (!btn) return;

    // Undgå andre knapper der genbruger klassen
    if (btn.type && btn.type !== 'submit') return;

    // Hvis disabled, gør intet
    if (btn.hasAttribute('disabled') || btn.classList.contains('disabled')) return;

    setTimeout(open, 250);
  }, true);

  // Upsell add-to-cart + refresh drawer
  if (btnAddUpsell) {
    btnAddUpsell.addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      const variantId = btn.dataset.variantId;

      console.log('[cm-popup-upsell] upsell click, variantId:', variantId);

      if (!variantId) return;

      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });

        console.log('[cm-popup-upsell] /cart/add.js status:', res.status);

        if (!res.ok) {
          btn.disabled = false;
          return;
        }

        close();
        await refreshCartDrawer();

        btn.disabled = false;
      } catch (err) {
        console.error('[cm-popup-upsell] upsell add error', err);
        btn.disabled = false;
      }
    });
  } else {
    console.warn('[cm-popup-upsell] no [data-cm-popup-add] button found in popup');
  }

  window.cmPopupUpsell = { open, close, refreshCartDrawer };
})();
